<script setup>
import { computed } from 'vue';
import { cn } from 'dashboard/components-next/ui-shadcn/utils';

const props = defineProps({
  class: { type: [String, Array, Object], default: '' },
});

const classes = computed(() =>
  cn('flex items-start justify-between gap-2 p-4', props.class)
);
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
